import { useCallback } from 'react';
import { useVerification } from '../../VerificationPopup/withVerification';
import { useRestrictToLoggedIn } from './useRestrictToLoggedIn';
import noop from '../noop';
/** returns whether current user:
 *    - is logged in
 *    - has verfified their email
 *  and a function that will:
 *    - send the user to the join page if they're logged out
 *    - open the verification popup if they haven't verified
 *    - call the given callback if logged in and verified
 */
export function useRestrictToLoggedInAndVerified() {
    var _a = useRestrictToLoggedIn(), isLoggedIn = _a.isLoggedIn, sendUserToJoinPage = _a.sendUserToJoinPage;
    var _b = useVerification(), isVerificationNeeded = _b.isVerificationNeeded, pushVerificationPopup = _b.pushVerificationPopup;
    var restrictToLoggedInAndVerified = useCallback(function (restrictedActionName, actionType, callback) {
        if (callback === void 0) { callback = noop; }
        return function (ev) {
            if (!isLoggedIn) {
                (ev === null || ev === void 0 ? void 0 : ev.preventDefault) && ev.preventDefault();
                return sendUserToJoinPage(restrictedActionName);
            }
            if (isVerificationNeeded) {
                (ev === null || ev === void 0 ? void 0 : ev.preventDefault) && ev.preventDefault();
                return pushVerificationPopup(actionType);
            }
            return callback();
        };
    }, [
        isLoggedIn,
        sendUserToJoinPage,
        isVerificationNeeded,
        pushVerificationPopup,
    ]);
    return { isLoggedIn: isLoggedIn, isVerificationNeeded: isVerificationNeeded, restrictToLoggedInAndVerified: restrictToLoggedInAndVerified };
}
//# sourceMappingURL=useRestrictToLoggedInAndVerified.js.map